import axios from "axios";

export default axios.create({
	baseURL: "https://api.qrpag.com.br/api",
	// baseURL: "http://localhost:8080",
	// baseURL: "https://api-qr-pag-h64ar4mnja-uw.a.run.app/api",
	timeout: 120000,
	headers: { "Content-type": "application/json", Accept: "application/json" },
});
